// Texto de "Como preencher e assinar" do card de emissão quando o cartório
// pede requerimento (status "Aguard. Req Cliente" na EMISSÃO PT).
// `certidao` e `titular` vêm de GET /central/emissoes.

// "Certidão de nascimento em inteiro teor digitada" → "certidão de nascimento".
export function tipoCertidao(certidao = "") {
  const tipo = certidao.match(/certid[aã]o (de|brasileira de) (nascimento|casamento|[oó]bito|uni[aã]o est[aá]vel)/i);
  return tipo ? `certidão de ${tipo[2].toLowerCase()}` : "certidão";
}

// "Certidão de nascimento reprográfica" → "certidão de nascimento em formato reprográfico".
export function descricaoCertidao(certidao = "") {
  const base = tipoCertidao(certidao);
  if (/reprogr[aá]fic/i.test(certidao)) return `${base} em formato reprográfico`;
  if (/inteiro teor/i.test(certidao)) return `${base} em inteiro teor`;
  if (/breve relato/i.test(certidao)) return `${base} em breve relato`;
  return base;
}

export function dataEmissaoRequerimento({ certidao, titular }) {
  const reprografica = /reprogr[aá]fic/i.test(certidao || "");

  return {
    titulo: `📄 Precisamos de uma autorização para solicitar sua ${tipoCertidao(certidao)}`,
    introducao: [
      `O cartório solicitou um **requerimento assinado** para liberar a ${descricaoCertidao(certidao)} de **${titular || "titular da certidão"}**.`,
      reprografica
        ? "A certidão reprográfica é uma reprodução fiel do registro original de nascimento. Para liberar esse documento, o cartório precisa confirmar quem está fazendo a solicitação."
        : "Para liberar esse documento, o cartório precisa confirmar quem está fazendo a solicitação.",
    ],
    secoes: [
      {
        titulo: "✍️ Quem deve assinar o requerimento?",
        itens: [
          "**A própria pessoa:** o titular da certidão deve preencher e assinar o requerimento.",
          "**Se a pessoa for falecida:** um parente em linha reta (como pai, mãe, filho, filha, avô, avó ou neto) deve assinar e enviar também a certidão de óbito.",
          "**Se a pessoa for menor de idade:** o requerimento deve ser assinado por seu responsável legal.",
        ],
      },
      {
        titulo: "📋 O que você precisa enviar?",
        numerada: true,
        itens: [
          "**Requerimento preenchido e assinado.**",
          "**RG digital ou CNH digital** da pessoa que assinou.",
          "**Certidão de óbito**, caso o titular da certidão seja falecido.",
        ],
        dica: "💡 **Dica:** o PDF do requerimento que enviamos é editável! Você pode preencher os campos diretamente no arquivo, sem precisar imprimir.",
      },
      {
        titulo: "🖊️ Como assinar o requerimento?",
        texto: "Você pode escolher uma das opções abaixo.",
        opcoes: [
          {
            titulo: "✅ Opção 1 — Assinatura digital (recomendada)",
            texto: "É a maneira mais rápida e prática, pois não exige deslocamento até um cartório.\n\nVocê pode assinar utilizando:",
            itens: [
              "**Gov.br:** assinatura eletrônica gratuita para contas com nível prata ou ouro.",
              "**Certificado digital ICP-Brasil:** caso possua um certificado válido.",
            ],
          },
          {
            titulo: "✅ Opção 2 — Assinatura com firma reconhecida",
            texto: "Se preferir assinar presencialmente:",
            numerada: true,
            itens: [
              "Preencha o requerimento.",
              "Assine o documento.",
              "Vá a um cartório para reconhecer sua firma.",
              "Envie uma foto ou digitalização bem legível do documento assinado e com o reconhecimento de firma.",
            ],
          },
        ],
      },
      {
        titulo: "💚 Importante",
        paragrafos: [
          "**O requerimento deve ser enviado junto com o documento de identificação de quem assinou.**",
          "Sem essa identificação, o cartório não conseguirá validar a solicitação, o que poderá atrasar a liberação da certidão.",
          "Após reunir os documentos, envie-os pela Central do Cliente para darmos continuidade ao seu pedido.",
        ],
      },
    ],
  };
}
